import React, { useEffect, useState } from "react";

import APIClient from "web_modules/APIClient";
import Spinner from "web_modules/shared/Spinner";
import { Indexes } from "@eave/shared/types/api";

import {
  decimalToFivePlaces,
  decimalToThreePlaces,
  timestampParse,
  timestampToDate,
} from "web_modules/capital_markets_dashboard/shared/utils";

import { IndexResponse } from "../interfaces";

const styles = require("./styles.module.scss");

interface Props {
  indexName: Indexes;
  lastUpdated: string; // TODO: jjw: used to re-trigger load effect; remove when using provider
}

const IndexHistory: React.FC<Props> = ({ indexName, lastUpdated }) => {
  const [ready, setReady] = useState<boolean>(false);
  const [history, setHistory] = useState<IndexResponse[]>([]);

  useEffect(() => {
    APIClient.get(`/cm/indexes?name=${indexName}`)
      .then(({ indexes }) => {
        setHistory(indexes);
      })
      .finally(() => {
        setReady(true);
      });
  }, [lastUpdated]);

  if (!ready) {
    return <Spinner active />;
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Historical {indexName}</h3>
      <div className={styles.details}>Last 60 days, most recent first</div>
      {history.length ? (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Index date</th>
              <th>Published {indexName}</th>
              <th>Truncated {indexName}</th>
              <th>45-day lookback</th>
            </tr>
          </thead>
          <tbody>
            {history.map(index => (
              <tr key={index.id}>
                <td>{timestampToDate(index.created_at)}</td>
                <td>{decimalToFivePlaces(index.value)}%</td>
                <td>{decimalToThreePlaces(index.rounded_value)}%</td>
                <td>
                  {timestampParse(index.created_at).subtract(45, "days").format("MM/DD/YYYY")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No history found for this index</p>
      )}
    </div>
  );
};

export default IndexHistory;
